/** Input types whose text a caret can move through; others, such as email or number, refuse selection ranges. */
const textFields = new Set(["text", "search", "url", "tel", "password"]);

/**
 * A modal focuses its first field with the prefilled text selected. On a touch screen a tap inside that selection
 * keeps it, so the first letter typed replaced the whole value, such as a relative's printed name. There the caret
 * goes after the text instead; a mouse click collapses the selection by itself.
 */
export function caretAfterPrefilledText(field: unknown, touch: boolean): void {
  const input = field as { tagName?: string; type?: string; value?: unknown; setSelectionRange?: unknown } | null;
  if (
    touch &&
    input?.tagName === "INPUT" &&
    textFields.has(input.type ?? "") &&
    typeof input.value === "string" &&
    typeof input.setSelectionRange === "function"
  ) {
    (input as HTMLInputElement).setSelectionRange(input.value.length, input.value.length);
  }
}
